<template>
  <b-modal
    class="modal-view-kpi text-muted"
    id="modal-view-kpi"
    centered
    hide-footer
    size="xl"
    title="View Detail Key Performance Indicator"
  >
    <div class="mt-3 mr-4 ml-4 mb-4">
      <h6 class="mb-3">Key Performance Indicator</h6>
      <b-table
        responsive
        striped
        :items="list"
        :fields="tableFields"
      >
      </b-table>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    kpi: {
      type: Array,
      default: () => []
    },
    objective: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      tableFields: [
        { key: 'objective', label: 'Objective', rowspan: 3, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'name', label: 'KPI', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'type', label: 'KPI Type', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'weight', label: 'Weight', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'target', label: 'Target', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'realization', label: 'Realization', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'score', label: 'Score', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'finalScore', label: 'Final Score', thClass: 'text-center', tdClass: 'text-center' }
      ]
    }
  },
  methods: {
    KpiType(type) {
      if (type === true) {
        return 'Maximize'
      } else {
        return 'Minimize'
      }
    }
  },
  watch: {
    kpi: {
      handler() {
        this.list = []
        this.kpi.forEach((item, i) => {
          this.objective.forEach(objective => {
            if (item.objectiveId === objective.id) {
              this.list.push({
                objective: objective.name,
                name: item.name,
                type: this.KpiType(item.type),
                weight: item.weight,
                target: item.target,
                realization: item.realization,
                score: item.score,
                finalScore: item.finalScore,
                _rowVariant: i % 2 === 0 ? 'warning' : null
              })
            }
          })
        })
      },
      immediate: true
    }
  }
}
</script>

<style>
.identity-employee{
  padding: 5px;
}
</style>
